import { DiffingTierColumn } from './diffing-tier-column';
import { Column } from 'react-table';
import { NumberColumn } from 'shared/tables/columns';
import { ViewContractsTiersGridItem } from 'shared/types/customerManagement';

export const viewContractsAgainstVolumeIncentiveTiersTableColumns: Column<ViewContractsTiersGridItem>[] = [
  {
    Header: 'Tier',
    align: 'left',
    isPrimary: true,
    accessor: 'tier',
    width: 20,
    minWidth: 20,
    Cell: NumberColumn,
  },
  {
    Header: 'Revenue',
    align: 'center',
    isPrimary: true,
    accessor: 'floor',
    section: 'volumeTiers',
    Cell: DiffingTierColumn,
  },
  {
    Header: 'Discount',
    align: 'center',
    isPrimary: true,
    accessor: 'rebate',
    section: 'volumeTiers',
    percent: true,
    Cell: DiffingTierColumn,
  },
  {
    Header: 'Compared Discount',
    align: 'center',
    isPrimary: true,
    accessor: 'diffingRebate',
    section: 'volumeTiers',
    percent: true,
    Cell: DiffingTierColumn,
    hidden: true,
  },
  {
    Header: 'Compared Revenue',
    align: 'center',
    isPrimary: true,
    accessor: 'diffingFloor',
    section: 'volumeTiers',
    Cell: DiffingTierColumn,
    hidden: true,
  },
];

export const hiddenColumns = viewContractsAgainstVolumeIncentiveTiersTableColumns.reduce<string[]>(
  (hiddenColumns, column) => {
    if (column.hidden) {
      hiddenColumns.push(String(column.accessor));
    }
    return hiddenColumns;
  },
  []
);
